module.exports = __webpack_public_path__ + "assets/img/nourishing_soup.c7db8a11.png";